import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { OauthService } from '../../pages/login/data-access/services/oauth.service';

export const authGuard: CanActivateFn = (_route, _state) => {
  const oauthService = inject(OauthService);
  const router = inject(Router);
  
  if (!oauthService.getToken()) {
    router.navigate(['/login']);
    return false;
  }
  return true;
};
